/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * helpers.ts - Helper functions for navigation
 * This file stops require cycles from importing the navigation index in to screen files.
 */

import { RootStackNavigationProp } from './types';

export function getCurrentRoute(navigation: RootStackNavigationProp) {
  const state = navigation.getState();
  return state.routes[state.index];
}
  